module.exports = __webpack_public_path__ + "img/cod.ba3b1bf7.svg";